/*global GridAndFormController, GridController, FormController, WebView*/
/** @this {GridAndFormController} */
var TrackedMailEmbeddable = function(options){    
    GridAndFormController.call(this,"iz_tracked_mail", 
    {
        grid: {
            directory: "views/tracked",
            name: window.app.context.isV2?"trackedMailGrid_v2":"trackedMailGrid",
            serverSideMode: true,            
            joinFetch: [
                { otherTable: "iz_tracked_mail_event", name: "events", type:"2many"},
                { otherTable: "ir_attachment", name: "attachs", type:"2many", thisField: "id", otherField: "res_id", joinSearch: {res_model: "iz.tracked.mail"}}
            ],
            canCreate: false
        },
        form: {
            directory: "views/tracked",
            name: "trackedMailForm",
            joinFetch: [
                { otherTable: "iz_tracked_mail_event", name: "events", type:"2many"},
                { otherTable: "ir_attachment", name: "attachs", type:"2many", thisField: "id", otherField: "res_id", joinSearch: {res_model: "iz.tracked.mail"}}
            ],
            buttonsHTML: FormController.globalsOptions.buttonsHTML
                .replace('id="btCreate"', 'id="btCreate" data-show-if="false"')
                .replace('id="btModify"', 'id="btModify" data-show-if="false"')
                .replace('id="btDelete"', 'id="btDelete" data-show-if="false"'),
            
        },
    }) ;


    this.gridController.prepareDataOnEnter = function(data, callback){
        if(data){
            //if we receive some data, we update the grid search options with a new
            //search criteria
            //the this.options object will be filled from HTML markup
            this.searchOptions = {
                res_model: options.searchmodel
            } ;
            if(options.searchid){
                this.searchOptions.res_id = WebView.pathExtract(data, options.searchid) ;
            }else{
                this.searchOptions.res_id = data.id ;
            }
        }
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;


    this.gridController.onDownload = 
    this.formController.onDownload = function(ev){
        var attach = ev.data.data ;
        this.view.longTask(function(done){
            this.api.readBinary.download(attach, attach.datas_fname, function(err){
                if(err){ return done(err) ;}
                done() ;
            }.bind(this)) ;
        }.bind(this)) ;
    } ;

    this.gridController.onDownloadAll = 
    this.formController.onDownloadAll = function(ev){
        var exp = ev.data.data ;
        this.view.longTask(function(done){
            var ids = exp.attachs.map(function(f){ return f.id ;}) ;
            this.api.readManyZip.download(ids, "attachs.zip", function(err){
                if(err){ return done(err) ;}
                done() ;
            }.bind(this))  ;
        }.bind(this)) ;
    } ;

    this.formController.onResendMail =
    this.gridController.onResendMail = function (ev) {
        const data = ev.data.data;
        var view = new WebView(null, null, {
            html: '<div data-field-def="iz_tracked_mail.to_addr"></div><div class="d-flex mt-2"><button type="button" class="btn btn-primary mr-auto" data-i18n="dinvoice.resend" id="resend" data-emit></button><button type="button" class="btn btn-primary ml-auto" data-i18n="dinvoice.resendManually" id="resendManually" data-emit></button></div>'
        });
        view.openInPopup({
            size: "medium"
        }, function () {
            view.render(data);
        }.bind(this));
        view.on("resend", function () {
            view.updateData();
            const data = view.getBoundObject();
            var records = [];
            let trackedMail = structuredClone(data);
            delete trackedMail.id;
            delete trackedMail.retry_mail_id;
            delete trackedMail.error;
            delete trackedMail.message_id;
            delete trackedMail.date_send;
            delete trackedMail.date_open;
            trackedMail.state = "tosend";
            delete trackedMail.attach;
            for(let to of ev.data.data.to_addr.split(/[,;]{1}/)){
                if(!to.trim()) continue; // Skip if the email address is empty

                var mail = JSON.parse(JSON.stringify(trackedMail));
                mail.to_addr = to.trim();
                
                records.push({
                    table: "iz_tracked_mail",
                    action: "insert",
                    record: mail
                });
                if (data.attachs) {
                    data.attachs.forEach(function (attach) {
                        attach = JSON.parse(JSON.stringify(attach));
                        delete attach.id;
                        attach.res_id = "${iz_tracked_mail.id}";
                        records.push({
                            table: "ir_attachment",
                            action: "insert",
                            record: attach
                        });
                    }.bind(this));
                }
            }
    
            view.close();
            this.view.longTask(function (done) {
                this.api.db.transactionalChanges(records, function (err) {
                    if (err) { return done(err); }
                    this.refresh(done);
                }.bind(this));
            }.bind(this));
        }.bind(this));
    
        view.on("resendManually", function () {
            view.updateData();
            view.close();
            const data = view.getBoundObject()
            this.view.longTask(function (done) {
                this.api.email.createEml(data.to_addr, data.subject, data.html, data.attachs.map(a => a.id).join(","), function (err) {
                    if (err) { return done(err); }
                    done();
                }.bind(this));
            }.bind(this));
        }.bind(this));
    };
} ;

TrackedMailEmbeddable.prototype = Object.create(GridAndFormController.prototype);
TrackedMailEmbeddable.prototype.constructor = TrackedMailEmbeddable;

module.exports = TrackedMailEmbeddable ;
